const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Reported At Depot',
  description: 'Reported At Depot',
  sortOrder: 1,
  name: 'reported_at_depot',
  documentKey: 'reported_at_depot',
  values: {
    reported_at_depot: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Reported At Depot',
      documentKey: 'reported_at_depot',
    },
  },
};
